import { Card } from "@/src/components/wrappers/Card";
import { Content } from "@/src/components/wrappers/Content";
import { ActionButton, WithActionBar } from "@/src/components/wrappers/WithActionBar";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function AddPayment() {
  return (
    <WithActionBar actionBar={<ActionBar />}>
      <Content title="Add a manual payment">
        <Card></Card>
      </Content>
    </WithActionBar>
  );
}

function ActionBar() {
  return (
    <div className="flex justify-end items-center">
      <ActionButton eventKey="payment:cancel" type="button" variant="secondary">
        <Link to="/payments">Cancel</Link>
      </ActionButton>
      <ActionButton eventKey="payment:save" type="button">
        Save Payment <ChevronRight size={16} className="ml-2" />
      </ActionButton>
    </div>
  );
}
